"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LibraryVideoCategory = void 0;
var LibraryVideoCategory;
(function (LibraryVideoCategory) {
    LibraryVideoCategory["BEAR"] = "BEAR";
    LibraryVideoCategory["STRESS_REDUCTION"] = "STRESS_REDUCTION";
})(LibraryVideoCategory = exports.LibraryVideoCategory || (exports.LibraryVideoCategory = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiTGlicmFyeVZpZGVvLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2ludGVyZmFjZXMvTGlicmFyeVZpZGVvLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUdBLElBQVksb0JBR1g7QUFIRCxXQUFZLG9CQUFvQjtJQUM5QixxQ0FBYSxDQUFBO0lBQ2IsNkRBQXFDLENBQUE7QUFDdkMsQ0FBQyxFQUhXLG9CQUFvQixHQUFwQiw0QkFBb0IsS0FBcEIsNEJBQW9CLFFBRy9CIn0=